import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Card, CardHeaderNumber, CardContentLine } from './MetricsCard';
import * as Price from '../util/Price';
import colors from '../styles/colors';
import { getFilteredContacts } from '../util/customersUtil';
import {
  DashboardFilteresTypes,
  DashboardFiltersSubTypes,
} from '../util/CustomerFilterEnum';
import { AppContext } from '../context/AppContext';
import useMutateAnalytics from '../util/mutate.Analytics';
import analyticsKeys from "../util/UsageStatLinks";

export default function CreditGrantedCard({ metrics, timeRange }) {
  const { setApp } = useContext(AppContext);

  const mutateAnalytics = useMutateAnalytics()
  const isNewClickable = metrics?.creditGrantedNew > 0;
  const isReturningClickable = metrics?.creditGrantedRepeat > 0;
  const isReferrersClickable = metrics?.creditGrantedAffiliate > 0;

  const onClickHandler = (subType) => getFilteredContacts(setApp, history, {
    type: DashboardFilteresTypes.CreditGranted,
    subType,
    ...timeRange,
  });

  const history = useHistory();
  return (
    <Card title="Credit Granted">
      <CardHeaderNumber>{`$${Price.output(
        metrics?.creditGrantedTotal,
        true,
      )}`}
      </CardHeaderNumber>
      <CardContentLine
        left="New Customers"
        right={`$${Price.output(metrics?.creditGrantedNew, true)}`}
        color={isNewClickable ? colors.seaGreen : colors.grey2}
        onClick={isNewClickable ? () => {
          const mutateAnalyticsVariables = {
            link: analyticsKeys.DASHBOARD_CREDIT_GRANTED_NEW_CUSTOMER,
          };
          mutateAnalytics(mutateAnalyticsVariables);
          onClickHandler(DashboardFiltersSubTypes.New);
        } : null}
      />

      <CardContentLine
        left="Returning Customers"
        right={`$${Price.output(metrics?.creditGrantedRepeat, true)}`}
        color={isReturningClickable ? colors.seaGreen : colors.grey2}
        onClick={isReturningClickable ? () => {
          const mutateAnalyticsVariables = {
            link: analyticsKeys.DASHBOARD_CREDIT_GRANTED_RETURNING_CUSTOMER,
          };
          mutateAnalytics(mutateAnalyticsVariables);
          onClickHandler(DashboardFiltersSubTypes.Returning);
        } : null}
      />

      <CardContentLine
        left="Referrers"
        right={`$${Price.output(metrics?.creditGrantedAffiliate, true)}`}
        color={isReferrersClickable ? colors.seaGreen : colors.grey2}
        onClick={isReferrersClickable ? () => {
          const mutateAnalyticsVariables = {
            link: analyticsKeys.DASHBOARD_CREDIT_GRANTED_REFERRERS_CUSTOMER,
          };
          mutateAnalytics(mutateAnalyticsVariables);
          onClickHandler(DashboardFiltersSubTypes.Referrers);
        } : null}
      />

    </Card>
  );
}
